import { Routes } from '@angular/router';
import { SmaPageComponent } from './layout/sma-page';
import { PageNotFoundComponent } from './static/page-not-found/page-not-found.component';
import { awardsRoutes } from './modules/awards';
import { awardCaseRoutes } from './modules/award-case';
import { candidatesRoutes } from './modules/candidates';
import { scannerResultsRoutes } from './modules/scanner';
import { organizationsRoutes } from './modules/organizations';
import { dashboardRoutes } from './modules/dashboard';
import { awardRequestArchiveRoutes, awardRequestRoutes } from './modules/award-request';
import { npaRoutes } from './modules/npa';
import { docRegistrationRoutes } from './modules/doc-registration';
import { workIndustryRoutes } from './modules/work-industry';
import { ERoutes } from './types/app-routes';
import { documentsRoutes } from './modules/documents';
import { awardReasonRoutes } from './modules/award-reason';
import { protocolsRoutes } from './modules/protocols';

export const routes: Routes = [
  {
    path: '',
    component: SmaPageComponent,
    children: [
      {
        path: '',
        redirectTo: ERoutes.DASHBOARD,
        pathMatch: 'full',
      },
      ...awardsRoutes,
      ...awardCaseRoutes,
      ...awardRequestRoutes,
      ...awardRequestArchiveRoutes,
      ...docRegistrationRoutes,
      ...candidatesRoutes,
      ...scannerResultsRoutes,
      ...organizationsRoutes,
      ...dashboardRoutes,
      ...npaRoutes,
      ...workIndustryRoutes,
      ...documentsRoutes,
      ...awardReasonRoutes,
      ...protocolsRoutes,
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
